import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

const vuexPersist = new VuexPersist({
  key: "aon-app",
  storage: localStorage
});

Vue.use(Vuex);

const getDefaultNewRequestState = () => {
  return {
    currentStep: 1,
    branch: null,
    conditions: {
      policy_number: "",
      validity_from: "",
      validity_to: "",
      assignment_percent_aon: "",
      assignmentValidityAonFrom: "",
      assignmentValidityAonTo: "",
      currency_id: null,
      controlZoneId: null
    }
  };
};

const getDefaultNewClaimState = () => {
  return {
    currentStep: 1,
    branch: null,
    request: null,
    conditions: {
      policy_number: "",
      validity_from: "",
      validity_to: "",
      assignment_percent_aon: "",
      assignmentValidityAonFrom: "",
      assignmentValidityAonTo: "",
      currency_id: null,
      controlZoneId: null
    }
  };
};

export default new Vuex.Store({
  state: {
    token: "",
    user: {},
    companyId: null,
    business: null,
    email: "",
    newRequest: getDefaultNewRequestState(),
    newClaim: getDefaultNewClaimState()
  },
  mutations: {
    setBusiness(state: any, business: any) {
      state.business = business;
    },
    setEmail(state: any, email: string) {
      state.email = email;
    },
    setToken(state: any, token: string) {
      state.token = token;
    },
    setUser(state: any, user: any) {
      state.user = user;
    },
    setCompanyId(state: any, companyId: any) {
      state.companyId = companyId;
    },
    setNewRequestBranch(state: any, branch: any) {
      state.newRequest.branch = branch;
      state.newRequest.currentStep = 2;
    },
    setNewClaimBranch(state: any, branch: any) {
      state.newClaim.branch = branch;
      state.newClaim.currentStep = 2;
    },
    setNewClaimRequest(state: any, request: any) {
      state.newClaim.request = request;
      state.newClaim.currentStep = 3;
    },
    setNewRequestConditions(state: any, data: any) {
      state.newRequest.conditions = { ...data };
      state.newRequest.currentStep = 3;
    },
    changeStep(state: any, data: any) {
      state.newRequest.currentStep = data;
    },
    clearNewClaim(state: any) {
      state.newRequest = getDefaultNewClaimState();
      window.location.href = "/claims/process-claims";
    },
    clearNewRequest(state: any, redirect = true) {
      state.newRequest = getDefaultNewRequestState();
      if (redirect) window.location.href = "/requests/process-requests";
    },
    logout(state: any) {
      state.token = "";
      state.user = {};
      state.companyId = null;
    }
  },
  actions: {},
  plugins: [vuexPersist.plugin]
});
